// ABOUTME: Progression modal shell for creating an Amazon FBA replenishment.
// ABOUTME: Mirrors MpAddBolReplenishment, surfacing the created header id via props.onCreated.
import { useTranslation } from "react-i18next";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";

import BasicDetails from "./views/BasicDetails";
import ProductDetails from "./views/ProductDetails";
import { useCreateAmazonreplenishmentMutation } from "../../../../newapi/webshop/amazonreplenishmentSlice";
const MpAddAmazonReplenishment = (props) => {
    const {t} = useTranslation();

    // ProgressionWrapper's handleSave passes the raw mutation response as the
    // first argument; the created record's id lives directly on response.id
    // (same contract MpDuplicateOrder relies on for its onSave).
    const onSave = (response) => {
        props.handleClose();
        props.onCreated?.(response?.id);
    }

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper onSave={onSave} query={useCreateAmazonreplenishmentMutation} isModal title={t("new_amazon_replenishment")}>
                <BasicDetails/>
                <ProductDetails/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpAddAmazonReplenishment;
